import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';
import AssessmentsListPage from '@/features/assessments/AssessmentsListPage';

/** `/testes` — config de plataforma da política de reuso dos assessments.
 *  SEM `companyId`/workspace: a política é global (spec 005). */
export const assessmentsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/testes',
  component: AssessmentsListPage,
});
